import { Label, Scalars } from '@generated/base-types';
import { ManagerError } from '@new/common/utils/error-parser';
import { PoolMetadataFragment } from '../../lib/services/pool/load-pool.generated';
import { UnlockedExamFragment } from '../../lib/services/tasks/unlocked-exams.generated';

/* Query actions */

export class LoadPool {
  public static readonly type = '[Pool] Load';
  constructor(public readonly id: Scalars['ID']) {}
}

export class LoadPoolSuccess {
  public static readonly type = '[Pool] Load success';
  constructor(public readonly pool: PoolMetadataFragment) {}
}

export class LoadPoolFailure {
  public static readonly type = '[Pool] Load failure';
  constructor(
    public readonly error: ManagerError,
    public readonly id: Scalars['ID']
  ) {}
}

export class LoadUnlockedExams {
  public static readonly type = '[Pool] Load unlocked exams';
  constructor(public readonly poolId: Scalars['ID']) {}
}

export class LoadUnlockedExamsSuccess {
  public static readonly type = '[Pool] Load unlocked exams success';
  constructor(public readonly unlockedExams: UnlockedExamFragment[]) {}
}

export class LoadUnlockedExamsFailure {
  public static readonly type = '[Pool] Load unlocked exams failure';
  constructor(public readonly error: ManagerError) {}
}

export class PoolExamAdded {
  public static readonly type = '[Pool] Exam added';
  constructor(
    public readonly exam: {
      id: Scalars['ID'];
      name: string;
      locked: boolean;
    }
  ) {}
}

export class PoolExamDeleted {
  public static readonly type = '[Pool] Exam deleted';
  constructor(public readonly examId: Scalars['ID']) {}
}

/* Label mutation actions */

export class CreateLabel {
  public static readonly type = '[Pool] Create label';
  constructor(public readonly name: string, public readonly color: string) {}
}

export class CreateLabelSuccess {
  public static readonly type = '[Pool] Create label success';
  constructor(public readonly label: Label) {}
}

export class CreateLabelFailure {
  public static readonly type = '[Pool] Create label failure';
  constructor(public readonly error: ManagerError) {}
}

export class UpdateLabel {
  public static readonly type = '[Pool] Update label';
  constructor(public readonly label: Label) {}
}

export class UpdateLabelSuccess {
  public static readonly type = '[Pool] Update label success';
  constructor(public readonly label: Label) {}
}

export class UpdateLabelFailure {
  public static readonly type = '[Pool] Update label failure';
  constructor(public readonly error: ManagerError) {}
}

export class DeleteLabel {
  public static readonly type = '[Pool] Delete label';
  constructor(public readonly labelId: Scalars['ID']) {}
}

export class DeleteLabelSuccess {
  public static readonly type = '[Pool] Delete label success';
  constructor(public readonly labelId: Scalars['ID']) {}
}

export class DeleteLabelFailure {
  public static readonly type = '[Pool] Delete label failure';
  constructor(public readonly error: ManagerError) {}
}

export class ReloadPool {
  public static readonly type = '[Pool] Reload pool';
}
